// JsFromRoutes CacheKey 80dcde6c0588b29b0e2a4e702d3834c9
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/users/:id/kiss'),
  frenchKissUser: /* #__PURE__ */ definePathHelper('post', '/users/:id/french_kiss'),
}
